import React from 'react';
import {FormGroup, Tag} from '@blueprintjs/core';

import {getFilename, getFilenameExtension, attachmentIsURL, attachmentIsNull} from './utils';
import {getDownloadUrl} from '../../utils';

import './DownloadAttachments.scss';

interface DownloadAttachmentsProps {
  uid: string;
  resultId: string; // last execution
  value: string[];
  inline?: boolean;
  className?: string;
}

export const DownloadAttachments = ({
  uid,
  resultId,
  value,
  inline = false,
  className,
}: DownloadAttachmentsProps) => {
  /*
   * Download attachments; used for preview or execution logs, where existing attachments can be downloaded.
   *
   * All attachments are S3 links, as we export everything to S3,
   *   then we give it to a "destination" type component (Email / Slack / S3, etc.) to handle the S3 URL.
   *
   */
  const openAttachment = (attachment: string) => {
    /*
     * Open attachment in a new window (get block result)
     */
    if (!attachmentIsURL(attachment)) {
      return;
    }

    const filename = getFilename(attachment);
    const extension = getFilenameExtension(filename);

    const url: string = getDownloadUrl(uid, resultId, extension, filename);

    window.open(url, '_blank');
  };

  return (
    <FormGroup
      label="Attachments"
      inline={inline}
      className={'download-attachments-input ' + (className || '')}
    >
      <div className="download-attachments-input__tags">
        {
          value?.filter(v => !attachmentIsNull(v))?.map((attachment: string) =>
            <Tag onClick={() => openAttachment(attachment)}>{getFilename(attachment)}</Tag>
          )
        }
      </div>
    </FormGroup>
  );
}
